import { InjectionToken } from '@angular/core';

export const AIDA_OEM_COMPATIBILITY_LIST: InjectionToken<string[]> = new InjectionToken('AIDA_OEM_COMPATIBILITY_LIST');
